/* V2
Site Top Navigation
 */

import * as React from "react"
import * as _ from "lodash"
import * as RoutesConfig from "../routes";
import IDoctorProfile from "../models/IDoctorProfile"
import { IAppState } from "../models/IAppState"
import { connect } from "react-redux"
import WindowUtils from "../utils/WindowUtils"
import AssetProvider from "../utils/AssetProvider"
import { RouteUtils } from "../routes"
import { ITwilioContext } from "../models/ITwilioContext";
import UnreadMessages from "./UnreadMessages";
import AppUtils from "../utils/AppUtils";
import { ORION_IMG_URL, FeatureConfigValues, APP_TENANTS } from "../utils/AppConstants";
import { IFeatureConfig } from "../models/IFeatureConfig";
import MobileMenu from "./MobileMenu";


export interface TopNavProps {
    doctorProfile: IDoctorProfile,
    twilioContext: ITwilioContext,
    featureConfigInfo: IFeatureConfig,
    appTenant: string,
}

export interface TopNavState {
    currUrl: string,
    messageWindow: boolean
}

export interface Nav {
    id: string,
    label: string,
    url: string
}

class TopNav extends React.Component<TopNavProps, TopNavState> {
    constructor(props: TopNavProps) {
        super(props);
        this.state = {
            currUrl: "",
            messageWindow: false
        }
    }

    logout = (e: any) => {
        e.preventDefault();

        // Clear all cookies
        AppUtils.logout();
    };

    render() {
        let myInstance = this;
        let doctorPrefix = !_.isEmpty(this.props.doctorProfile.prefix) && this.props.doctorProfile.prefix.toLowerCase().indexOf("dr") !== -1 ? this.props.doctorProfile.prefix + " " : ""
        const isMobile: boolean = AppUtils.getIsMobile();
        const isTransformCoach = this.props.doctorProfile.resourceServiceMapping && AppUtils.checkForTransformCoach(this.props.doctorProfile.resourceServiceMapping);
        const routesList = isTransformCoach ? RoutesConfig.TRANSFORM_TOP_NAVS : RoutesConfig.APP_TOP_NAVS;
        const appTenant = this.props.appTenant;

        const allowedNavs: Nav[] = routesList.filter((value: RoutesConfig.NavConfig) => {
            if (value.featureEnabledKey) {
                return (this.props.featureConfigInfo[value.featureEnabledKey] === FeatureConfigValues.TRUE)
            }
            else {
                return true
            }
        })

        return (
            <div className="navbar navbar-inverse top-nav">
                <div className="container-fluid navs-container">
                    {AppUtils.getIsMobile() && <MobileMenu navs={allowedNavs} />}
                    <div className="navbar-brand" onClick={() => RouteUtils.navigateToDashboard()}>
                        {appTenant === APP_TENANTS.SUGARFIT ?
                            <img src={'/images/sugarfit_logo.svg'} style={{ height: 31, marginLeft: 9 }} />
                            : <img src={ORION_IMG_URL + "carefit-logo.png"} style={{ height: "40px" }} />
                        }
                    </div>
                    <div className="top-center-navs">
                        {
                            _.map(allowedNavs, function (topNav, index) {
                                // let selectedCls =  WindowUtils.isWindowLocation(topNav.url) ? "selected" : "";
                                let selectedCls = WindowUtils.isWindowLocation(topNav.url) ? "selected" : "";
                                return (
                                    <a className={"simple-anchor top-center-nav " + selectedCls} href={topNav.url}
                                        key={index}
                                        onClick={(e) => {
                                            RouteUtils.navigateToHrefUrl(e, topNav.url);
                                            myInstance.setState({ currUrl: topNav.url })
                                        }}>
                                        {topNav.label}
                                    </a>
                                )
                            })
                        }
                    </div>
                    <div className={`top-right-navs pull-right ${isMobile ? "mobile" : ""}`}>
                        <UnreadMessages />
                        <div className={`top-right-nav ${isMobile ? "hidden" : ""}`}>
                            <a className="simple-anchor doctor-profile" href={RoutesConfig.DOC_PROFILE}
                                onClick={(e) => RouteUtils.navigateToHrefUrl(e, RoutesConfig.DOC_PROFILE)}>
                                <img src={AssetProvider.getDoctorImage(this.props.doctorProfile)}></img>
                                <span>{doctorPrefix + "" + this.props.doctorProfile.name}</span>
                            </a>
                        </div>
                        {!AppUtils.getIsMobile() && (
                            <div className={"top-right-nav"}>
                                <a href="/" onClick={this.logout}><img className={"logout-button"}
                                    src={ORION_IMG_URL + "icons/power.svg"} title="Logout" /></a>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        )
    }
}


const mapStateToProps = (state: IAppState): any => {
    return {
        doctorProfile: state.doctorProfile,
        twilioContext: state.twilioContext,
        featureConfigInfo: state.featureConfigInfo,
        appTenant: state.accountData.appTenant,
    }
}

export default connect(mapStateToProps)(TopNav);
